module.exports = __webpack_public_path__ + "static/media/bright-background.d2a9301f.webp";